import { render, staticRenderFns } from "./FrontTemplate.vue?vue&type=template&id=432eb337&scoped=true"
import script from "./FrontTemplate.vue?vue&type=script&lang=js"
export * from "./FrontTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432eb337",
  null
  
)

export default component.exports